import type { IconProps } from '../../../components/Icon/Icon.util';

export const Trash = ({
  title,
  width = 32,
  height = 32,
  fill = 'none',
  role = 'presentation',
}: IconProps): React.ReactNode => {
  const viewBoxSize = 32;

  return (
    <svg
      fill={fill}
      focusable='false'
      height={height}
      role={role}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      {title ? <title>{title}</title> : null}

      <path d='M17 15C17 14.4477 16.5523 14 16 14C15.4477 14 15 14.4477 15 15V25C15 25.5523 15.4477 26 16 26C16.5523 26 17 25.5523 17 25V15Z' />
      <path d='M21 14C21.5523 14 22 14.4477 22 15V25C22 25.5523 21.5523 26 21 26C20.4477 26 20 25.5523 20 25V15C20 14.4477 20.4477 14 21 14Z' />
      <path d='M12 15C12 14.4477 11.5523 14 11 14C10.4477 14 10 14.4477 10 15V25C10 25.5523 10.4477 26 11 26C11.5523 26 12 25.5523 12 25V15Z' />
      <path
        clipRule='evenodd'
        d='M12.7101 2.36259C12.0773 2.99537 11.6457 3.79167 11.4563 4.65217H8.43478C7.52382 4.65217 6.65017 5.01405 6.00602 5.6582C5.36188 6.30235 5 7.176 5 8.08696V9.30435L5.00004 9.31281H4C3.44772 9.31281 3 9.76052 3 10.3128C3 10.8651 3.44772 11.3128 4 11.3128H5.65217V27.5652C5.65217 28.4762 6.01405 29.3498 6.6582 29.994C7.30234 30.6381 8.17599 31 9.08696 31H22.913C23.824 31 24.6977 30.6381 25.3418 29.994C25.9859 29.3498 26.3478 28.4762 26.3478 27.5652V11.3128H28C28.5523 11.3128 29 10.8651 29 10.3128C29 9.76052 28.5523 9.31281 28 9.31281H27L27 9.30435V8.08696C27 7.17599 26.6381 6.30234 25.994 5.6582C25.3498 5.01405 24.4762 4.65217 23.5652 4.65217H20.5431C20.3537 3.79167 19.9221 2.99537 19.2893 2.36259C18.4168 1.49014 17.2335 1 15.9997 1C14.7659 1 13.5826 1.49014 12.7101 2.36259ZM15.9997 3C15.2963 3 14.6217 3.27942 14.1243 3.7768C13.8718 4.02937 13.6754 4.32764 13.5433 4.65217H18.4561C18.324 4.32764 18.1276 4.02937 17.8751 3.7768C17.3777 3.27942 16.7031 3 15.9997 3ZM23.5652 6.65217H8.43478C8.05425 6.65217 7.68931 6.80334 7.42024 7.07241C7.15117 7.34149 7 7.70643 7 8.08696V9.30435L6.99996 9.31281H25L25 9.30435V8.08696C25 7.70643 24.8488 7.34149 24.5798 7.07241C24.3107 6.80334 23.9457 6.65217 23.5652 6.65217ZM7.65217 27.5652V11.3128H24.3478V27.5652C24.3478 27.9457 24.1967 28.3107 23.9276 28.5798C23.6585 28.8488 23.2936 29 22.913 29H9.08696C8.70643 29 8.34149 28.8488 8.07241 28.5798C7.80334 28.3107 7.65217 27.9457 7.65217 27.5652Z'
        fillRule='evenodd'
      />
    </svg>
  );
};
